"use client";

import React from "react";
import { StyledDiv } from "./affiliatesDosDonts.styles";

export const AffiliatesDosDonts = ({
  yesDo = [],
  noDo = [],
  className = "",
}: {
  yesDo: string[];
  noDo: string[];
  className?: string;
}) => {
  return (
    <StyledDiv className={className}>
      <h2>Do’s & Don’ts</h2>
      <div className="rules-wrapper">
        <div className="can">
          <h6>You Can</h6>
          <ul>
            {yesDo.map((yesDoText, idx) => (
              <li key={`${yesDoText}-${idx}`}>{yesDoText}</li>
            ))}
          </ul>
        </div>
        <div className="cant">
          <h6>You {`Can't`}</h6>
          <ul>
            {noDo.map((noDoText, idx) => (
              <li key={`${noDoText}-${idx}`}>{noDoText}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="small">
        <p className="dark">
          Any violation of the above term will result in your account being
          permanently banned.
        </p>
        <p>
          We reserve the right to change the Terms of Service for our affiliate
          program at any time.
        </p>
      </div>
    </StyledDiv>
  );
};
